<template>
  <div class="container">
    <el-button class="mwow-button-filled success" @click="showAddDialog"
      >添加教室</el-button
    >
    <div class="formInfo">
      <el-form
        :model="fromData"
        size="mini"
        ref="form"
        inline
        @submit.native.prevent
      >
        <el-form-item label="教室名称:">
          <el-input
            prefix-icon="el-icon-search"
            placeholder="请搜索"
            v-model="fromData.class_name"
            @change="handleSearch"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
        :data="tableData"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        @sort-change="clickSort"
        :default-sort="{ prop: 'create_time', order: 'descending' }"
      >
        <el-table-column prop="name" label="教室名称"> </el-table-column>
        <el-table-column prop="people" label="教室人数"> </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <div>{{ scope.row.remark ? scope.row.remark : "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>
              {{ getTime(new Date(Number(scope.row.create_time + "000"))) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot="header">
            <div class="header-in">
              <div>操作</div>
              <el-popover
                placement="top"
                width="190"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">点击 “预览” 可查看已在教室中排课的课次</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div
              class="mwow-button success caozuo"
              @click="editClassRoom(scope.row)"
            >
              编辑
            </div>
            <div
              class="mwow-button success caozuo"
              @click="goClassRoomTimeTable(scope.row)"
            >
              预览
            </div>
            <div class="mwow-button" @click="delClassRoom(scope.row)">删除</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="pageSizeArray"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 抽屉 -->
    <el-drawer
      :title="titleName === 1 ? '添加教室' : '编辑教室'"
      :visible.sync="addClassRoomDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
    >
      <add-dialog
        :visible.sync="addClassRoomDrawerVisible"
        :edit-info="titleName === 2 ? editInfo : ''"
      ></add-dialog>
    </el-drawer>
  </div>
</template>
<script>
import { classroomListApi, classroomDelApi } from "@/api/classRoom";
import addDialog from "@/components/addClassRoomDialog.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
export default {
  components: {
    addDialog,
  },
  data() {
    return {
      fromData: {
        class_name: "",
        sort_type: "desc",
        sort_field: "create_time",
      },
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      addClassRoomDrawerVisible: false,
      titleName: 0, // 决定显示名称
      editInfo: {},
    };
  },
  created() {
    eventBus.$on("initClassRoomManagement", () => {
      this.getList({
        page: 1,
        page_size: 10,
      });
    });
    this.getList({
      page: 1,
      page_size: 10,
    });
  },
  beforeDestroy() {
    eventBus.$off("initClassRoomManagement");
  },
  methods: {
    goClassRoomTimeTable(it) {
      this.$router.push({
        name: "storeSchedule",
        query: {
          fromClassroomId: it.classroom_id,
        },
      });
    },
    getList(data) {
      const option = {
        page: data.page,
        page_size: data.page_size,
      };
      if (this.fromData.class_name) {
        option.name = this.fromData.class_name;
      }
      if (this.fromData.sort_type) {
        option.sort_type = this.fromData.sort_type;
      }
      if (this.fromData.sort_field) {
        option.sort_field = this.fromData.sort_field;
      }
      classroomListApi(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    getTime(e) {
      // let weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      // let v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + " " + format.slice(11);
    },
    clickSort(e) {
      this.fromData.sort_field = e.prop;
      if (e.order == "descending") {
        this.fromData.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.fromData.sort_type = "asc";
      } else {
        this.fromData.sort_type = "";
      }
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: 10,
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    delClassRoom(delInfo) {
      this.$confirm(
        "删除教室后，已分配教室的班级、课次则不再显示教室信息，确定要删除教室？",
        `删除教室 - ${delInfo.name}`,
        {
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonClass: "mwow-button-filled success",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          classroomDelApi({
            classroom_id: delInfo.classroom_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                message: "教室已删除",
                type: "success",
              });
              eventBus.$emit("initClassRoomManagement");
            }
          });
        })
        .catch(() => {});
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    showAddDialog() {
      this.addClassRoomDrawerVisible = true;
      this.titleName = 1;
    },
    editClassRoom(edit) {
      this.editInfo = edit;
      this.addClassRoomDrawerVisible = true;
      this.titleName = 2;
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  .formInfo {
    margin-top: 20px;
  }
  .caozuo {
    margin-right: 5px;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.header-in {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
</style>
